// Product overview drawer (sections/product-overview-drawer.liquid).
// custom-global.js still fetches, injects, opens and closes the drawer. This file only adds what that loader
// does not do, and only when the injected content is a .pod-drawer: focus on open, Tab kept inside, Escape closes
// it, focus goes back to the trigger (also after an overlay click), and the video pause buttons work.
(() => {
  if (window.podDrawerInitialized) return;
  window.podDrawerInitialized = true;

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastTrigger = null;
  let active = null;

  const close = () => active?.drawer.querySelector('[js-shutdown-drawer]')?.click();
  const focusables = (drawer) => [...drawer.querySelectorAll(FOCUSABLE)].filter((el) => el.getClientRects().length > 0);

  // Capture phase, so the trigger is known before drawer-open starts its fetch.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('drawer-open, drawer-open-md');
    if (trigger) lastTrigger = event.target.closest('button, a, [tabindex]') || trigger;
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusables(active.drawer);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (!active.drawer.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const initVideoToggles = (drawer) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    drawer.querySelectorAll('[data-pod-video-toggle]').forEach((button) => {
      const video = button.parentElement.querySelector('video');
      if (!video) return;
      const sync = () => {
        button.classList.toggle('is-paused', video.paused);
        button.setAttribute('aria-label', video.paused ? button.dataset.labelPlay : button.dataset.labelPause);
      };
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
      }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (video.paused) video.play().catch(sync);
        else video.pause();
      });
      sync();
    });
  };

  document.addEventListener('customDrawer:loaded', (event) => {
    const container = event.target;
    const drawer = container.querySelector?.('.pod-drawer');
    if (!drawer) return;
    const current = { drawer, trigger: lastTrigger };
    active = current;
    initVideoToggles(drawer);

    // The loader closes by emptying the container; that is our cue to hand focus back.
    const observer = new MutationObserver(() => {
      if (container.contains(drawer)) return;
      observer.disconnect();
      if (active !== current) return;
      active = null;
      if (current.trigger?.isConnected) current.trigger.focus({ preventScroll: true });
    });
    observer.observe(container, { childList: true });

    // The shell's visibility is transitioned, so focus() is ignored until it is visible. Retry briefly.
    const closeButton = drawer.querySelector('.pod-drawer__close');
    const started = Date.now();
    const focusClose = () => {
      if (active !== current || !closeButton) return;
      closeButton.focus({ preventScroll: true });
      if (document.activeElement !== closeButton && Date.now() - started < 1000) setTimeout(focusClose, 50);
    };
    requestAnimationFrame(focusClose);
  });
})();
